/* eslint-disable camelcase */
import { APIReference_apiReference_ClassReference_method_return as ClassMethodReturns } from '@modules/client';
import { useTranslation } from '@rbx/intl';
import { Typography } from '@rbx/ui';
import StandardMarkdownNoMargin from '@modules/ui/markdown/components/StandardMarkdownNoMargin';
import ContentTable from '@modules/ui/shared/components/ContentTable';
import React, { Fragment, FunctionComponent } from 'react';
import LinkableTypeReference from './LinkableTypeReference';
import useParameterReturnTableStyles from './ParameterReturnTable.styles';

interface ReturnsTableProps {
  returnsList: ClassMethodReturns[] | null;
}

const ReturnsTable: FunctionComponent<React.PropsWithChildren<ReturnsTableProps>> = ({
  returnsList,
}) => {
  const { translate } = useTranslation();
  const {
    classes: { title },
  } = useParameterReturnTableStyles();
  if (returnsList === null) {
    return null;
  }

  return (
    <Fragment>
      <Typography className={title} variant='h4' component='h4'>
        {translate('Label.Returns') || 'Returns'}
      </Typography>
      <ContentTable
        data={returnsList}
        renderer={(row) => {
          const { type, summary } = row as ClassMethodReturns;
          return {
            name: <LinkableTypeReference type={type} variant='body2' />,
            summary: summary && <StandardMarkdownNoMargin>{summary}</StandardMarkdownNoMargin>,
          };
        }}
      />
    </Fragment>
  );
};

export default ReturnsTable;
